<template>
    <div>
        <div v-if="this.isOptometrist==0">
            <br><br>
            <div v-if="this.studentCheckResut!=null">
                <el-descriptions title="学生基本信息" size="medium" :column="1" border>
                    <el-descriptions-item label="学生姓名">{{ this.studentCheckResut.studentName }}</el-descriptions-item>
                    <el-descriptions-item label="学校名称">{{ this.studentCheckResut.schoolName }}</el-descriptions-item>
                    <el-descriptions-item label="班级名称">{{ this.studentCheckResut.className }}</el-descriptions-item>
                </el-descriptions>
                <br><br>
                <el-descriptions v-if="this.studentCheckResut.nakedlefteye!=0" title="视力检查结果" size="medium" :column="2" border>
                    <el-descriptions-item label="左眼裸眼视力">{{ this.studentCheckResut.nakedlefteye }}</el-descriptions-item>
                    <el-descriptions-item label="右眼裸眼视力">{{ this.studentCheckResut.nakedrighteye }}</el-descriptions-item>
                    <el-descriptions-item label="左眼屈光轴位A">{{ this.studentCheckResut.leftoaa }}</el-descriptions-item>
                    <el-descriptions-item label="右眼屈光轴位A">{{ this.studentCheckResut.rightoaa }}</el-descriptions-item>
                    <el-descriptions-item label="左眼屈光柱镜C">{{ this.studentCheckResut.leftopc }}</el-descriptions-item>
                    <el-descriptions-item label="右眼屈光柱镜C">{{ this.studentCheckResut.rightopc }}</el-descriptions-item>
                    <el-descriptions-item label="左眼屈光球镜S">{{ this.studentCheckResut.leftobs }}</el-descriptions-item>
                    <el-descriptions-item label="右眼屈光球镜S">{{ this.studentCheckResut.rightobs }}</el-descriptions-item>
                </el-descriptions>
                <br><br>
                <el-descriptions title="视力状况及建议" size="medium" :column="1" border>
                    <el-descriptions-item label="视力状况">{{ this.studentCheckResut.visualCondition }}</el-descriptions-item>
                    <el-descriptions-item label="视力建议">{{ this.studentCheckResut.suggest }}</el-descriptions-item>
                </el-descriptions>
                <!--<el-button type="primary" icon="el-icon-plus" @click="exportCheckList()">下载检查单</el-button>-->
            </div>
        </div>
        <div v-if="this.isOptometrist==1">
            <VisualRegister
                    v-if="isShowInput"
                    :serialNo="this.serialNo"
                    :openid="this.openid"
            />
        </div>
    </div>

</template>

<script>
    import VisualRegister from "@/views/emp/visualregister/EmpVisualRegister"
    import FileSaver from "file-saver";
  import wx from "weixin-js-sdk"; // 微信JS - Sdk
  //import { getWxSign } from '@/api/weiChat.js'
    export default {
        name: "scan",
        components: {
            VisualRegister
        },
      mounted(){
            this.openid = this.getQueryString("openid"); // 参数名1
          this.getIsOptometrist();
            this.scan()
      },
      data() {
          return {
              openid:'',
              isOptometrist:-1,  //1-是验光师，0-不是验光师
              studentCheckResut:null,
              serialNo: '',
              isShowInput: false,
              filterParam: {
                  schoolName: "",
                  className: '',
                  studentName: '',
                  keyword: '',
                  title: '前端测试title',
                  djbTitle: '前端测试登记表title',
                  djbSubhead: "测试副标题",
                  serialNo: ""
              },
          }
      },
      methods:{
        getQueryString(name) {
              const reg = `(^|&)${name}=([^&]*)(&|$)`;
              const r = window.location.search.substr(1).match(reg);
              if (r != null) return unescape(r[2]);
              return null;
          },
          getIsOptometrist(){
              let _this=this
              this.getRequest('/api/wechatMenu/isOptometrist?openid='+this.openid).then((res) => {
                  console.log('isOptometrist:'+res.message)
                  _this.isOptometrist=res.message
              })
        },
        scan(){
            let _this=this
            this.getRequest('/api/wechatMenu/getWxConfigs?openid='+this.openid).then((res) => {
              this.jsonData = JSON.parse(res.message);
              wx.config({
                  // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                  debug: false,
                  // 必填，公众号的唯一标识
                  appId: this.jsonData.appId,
                  // 必填，生成签名的时间戳
                  timestamp: "" + this.jsonData.wxConfig.timestamp,
                  // 必填，生成签名的随机串
                  nonceStr: this.jsonData.wxConfig.nonceStr,
                  // 必填，签名
                  signature: this.jsonData.wxConfig.signature,
                  // 必填，需要使用的JS接口列表，所有JS接口列表
                  jsApiList: ['checkJsApi', 'scanQRCode']
              });

          });
          wx.error(function (res) {
            alert("出错了：" + res.errMsg);//这个地方的好处就是wx.config配置错误，会弹出窗口哪里错误，然后根据微信文档查询即可。
          });

          wx.ready(function () {
            //alert("111")
            wx.scanQRCode({
              needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
              scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
              success: function (res) {
                var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                  // result='1234'
                  // _this.openid='onpoVt1QKJbtDGTFI2JVY9E35GOs'
                  // console.log(result+','+_this.openid)
                  _this.serialNo=result
                  _this.isShowInput=_this.isOptometrist?true:false
                //alert(result+','+_this.openid);
                  _this.getRequest('/employee/basic/getVisualInfoBySerialNo?openId='+_this.openid+'&serialNo='+result).then((res) => {
                      //console.log('isOptometrist:'+res.message)
                      //_this.isOptometrist=res.message
                      if(res.status){
                          _this.studentCheckResut=res.data
                          //console.log('data:'+res.message)
                      }
                  })
              }
            });

          });
        },
          async exportCheckList() {
              console.log("导出检查单...")
              this.loading = true;
              this.filterParam.serialNo=this.studentCheckResut.serialNo
              let queryParam = {
                  ...this.filterParam
              }
              try {
                  this.getRequest('/employee/basic/downloadCheckListReport', {
                      params: queryParam,
                      responseType: 'arraybuffer',
                      timeout: 50000
                  }).then((res) => {
                      FileSaver.saveAs(
                          new Blob([res], {
                              type: `application/force-download`
                          }),
                          `checkList.zip`
                      );
                  });
                  this.showCreateCheckListDialog = false
                  this.loading = false;
              } catch (error) {
                  alert('文件下载失败');
              }
          },
      }
    }
</script>

<style scoped>

</style>
